<template>
  <div class="progress-stepper">
    <v-stepper v-model="current" non-linear alt-labels>
      <v-stepper-header>
        <template v-for="n in steps">
          <v-stepper-step
            :key="`${n.value}-step`"
            :complete="current > n.value"
            :step="n.value"
            editable
          >
          {{n.label}}
          </v-stepper-step>
            <v-divider
              v-if="n.value < steps.length"
              :key="n.value"
              :class="current > n.value?'active':''"
            ></v-divider>
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content
          v-for="n in steps"
          :key="`${n.value}-content`"
          :step="n.value"
        >
          <slot name="stepper-content">
            <v-card
              class="mb-12"
              color="grey lighten-1"
              height="200px"
            ></v-card>
          </slot>

          <v-btn
            class="v-btn--primary"
            @click="nextStep(n)"
          >
            Continue
          </v-btn>

          <v-btn text class="v-btn--secondary">
            Cancel
          </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        current: 1,
      }
    },
    props:{
        steps:{
            type: Array,
            default:[{value:1,label:"inicio"},{value:2,label:"medio"},{value:3, label:"fin"}],
        }
    },

    watch: {
      steps (val) {
        if (this.current > val) {
          this.current = val
        }
      },
    },

    methods: {
      nextStep (n) {
        if (n.value === this.steps.length) {
          this.current = 1
        } else {
          this.current = n.value + 1
        }
      },
    },
  }
</script>